export const calculateShippingCosts = (shippingCost, minPurchaseForFreeShipping, cartTotal) => {
  if (cartTotal >= minPurchaseForFreeShipping) {
    return 0;
  }
  return shippingCost;
};

export const calculateTotalOrderSummary = (discountCart, total, shippingCosts) => {
  if (discountCart?.type === 'percentage') {
    return total.toFixed(2);
  } else {
    return (Number(total + shippingCosts).toFixed(2));
  }
};

export const calculateDiscountAmount = (subtotal, iva, pencentageDiscount) => {
  return ((subtotal + iva) * pencentageDiscount/100).toFixed(2);
};

export const calculateTotalOrderWithDiscount = (subtotal, iva, amountDiscount, shippingCosts) => {
  return ((subtotal + iva) - amountDiscount + shippingCosts).toFixed(2)
};